import initialState from './paymentTypeInitialState';

export default function paymentTypeReducer(state = initialState) {
    return state;
}
